// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__okN7F","title":"ClientCherryInfo_title__2_LuU","itemText":"ClientCherryInfo_itemText__1vNqY"};